import { createSelector } from 'reselect';

import { getPageData } from '../reducers/pdp/selectors';

export const getSingleSampleSampleSku = createSelector(
  getPageData,
  pageData => pageData.singleSampleSku
);

export const getMultiSampleState = state => state.cards.cardCatalog.multiSampleState;
